import React from 'react';
import { useLocation } from 'react-router-dom';
import AssignmentEditor from './asoebiAssignments/AssignmentEditor';
import AssignmentsList from './asoebiAssignments/AssignmentsList';
import { ENTITY_PREFIX } from '../utils/entityRoutes';
import { parseId } from '../utils/jiraId';
import '../styles/components/AsoebiAssignments.css';

const ROOT = '/asoebi/assignments';

/**
 * Asoebi > Assignments: the packing of each asoebi order.
 *   /asoebi/assignments        the list (cards by packing state, Archived switch, Filters, Mark packed)
 *   /asoebi/assignments/new    create (optionally ?order=<order id>)
 *   /asoebi/assignments/AZ-..  one assignment: checklist to pack, fields, Save / Delete
 * The URL is the only state that says which page is open, so every row is a real link.
 *
 * Mounting: render <AsoebiAssignmentsView /> as the 'assignments' tab body of AsoebiManager
 * ({activeTab === 'assignments' && <AsoebiAssignmentsView />}). It draws its own breadcrumb bar
 * until Header.tsx learns the 'asoebi-assignments' view.
 */
const AsoebiAssignmentsView: React.FC = () => {
  const { pathname } = useLocation();
  const rest = pathname.startsWith(ROOT) ? pathname.slice(ROOT.length).replace(/^\/+/, '').split('/')[0] : '';
  if (!rest) return <AssignmentsList />;
  if (rest === 'new') return <AssignmentEditor />;
  let decoded = rest;
  try { decoded = decodeURIComponent(rest); } catch { /* keep the raw segment */ }
  return <AssignmentEditor id={parseId(ENTITY_PREFIX.asoebiAssignment, decoded) ?? decoded} key={decoded} />;
};

export default AsoebiAssignmentsView;
